export const checkTranslationKey = (key: string, defaultText: string) => {
  if (key === undefined) {
    return defaultText;
  }

  return key;
};
